// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopReclamationControllerCreateData } from './EshopReclamationControllerCreateData.gen';
import type { EshopReclamationControllerCreateErrors } from './EshopReclamationControllerCreateErrors.gen';
import type { EshopReclamationControllerCreateResponses } from './EshopReclamationControllerCreateResponses.gen';
import type { Options } from './Options.gen';

export class EshopReclamationController {
    /**
     * Create a eshop reclamation.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **ESHOP_RECLAMATION_NOT_ALLOWED** - Eshop reclamations are not enabled<br>
     * + **INVALID_GDPR_OR_TERMS_APPROVAL** - GDPR, terms and conditions must be approved.
     */
    public static create<ThrowOnError extends boolean = false>(options: Options<EshopReclamationControllerCreateData, ThrowOnError>) {
        return (options.client ?? client).post<EshopReclamationControllerCreateResponses, EshopReclamationControllerCreateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/reclamations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
